"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    properties: _propTypes["default"].oneOfType([_propTypes["default"].shape({
      analysed: _propTypes["default"].bool.isRequired
    }).isRequired, _propTypes["default"].shape({
      contrastName: _propTypes["default"].string.isRequired,
      referenceOrTest: _propTypes["default"].oneOf(["reference", "test", ""])
    }).isRequired]),
    values: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired).isRequired
  }).isRequired).isRequired,
  headers: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    values: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired
  }).isRequired).isRequired
};
exports["default"] = _default;